// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.amenities.apartments.RentalManagerUserPropertyApartmentAmenityV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_create,
  RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_delete,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyApartmentAmenityCreateResponseV2WebDto,
  UserPropertyApartmentAmenityCreateV2RequestDto,
  UserPropertyApartmentAmenityDeleteV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_create_Args {
  postData: UserPropertyApartmentAmenityCreateV2RequestDto;
}

export type RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_create_Options = UseMutationOptions<
  UserPropertyApartmentAmenityCreateResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_create_Args
>;

/**
 * Create a free text apartment amenity
 */
export const useRentalManagerUserPropertyApartmentAmenityV2WebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_create_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_create_Args) =>
      RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_create(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_delete_Args {
  postData: UserPropertyApartmentAmenityDeleteV2RequestDto;
}

export type RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_delete_Args
>;

/**
 * Delete a free text apartment amenity
 */
export const useRentalManagerUserPropertyApartmentAmenityV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_delete_Args) =>
      RentalManagerUserPropertyApartmentAmenityV2WebApiHandler_delete(args.postData, httpClient),
  });
};
